export default "__VITE_ASSET__f85d5cdb__"